export default {
	LAZY: 'LAZY',
	EAGER: 'EAGER',
};
